import { createContext } from "react";

export const PersonContext = createContext({});